<template>
	<div class="news_center">
		<div class="nc_pc pt_90" v-if="!isPhone">
			<pageBanner :imgurl="banner"></pageBanner>
			<div class="news_sort">
				<div class="sort_list flex1">
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>集团要闻</span>
								<span>/&nbsp; Group News</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(1)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item, index) in nlist1" :key="item.id" @click="toDetail(item, 1)">
							<div class="soem_item1 flex3" v-if="index == 0">
								<div class="soem_item1_left">
									<img :src="item.image">
								</div>
								<div class="soem_item1_right">
									<div class="srt_date flex3">
										<img src="@/images/rili_blue.png">
										<span>{{ item.addtime.slice(0, 10) }}</span>
									</div>
									<div class="srt_pt1 ellip3">{{ item.title }}</div>
								</div>
							</div>
							<div v-if="index > 0" class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>基层动态</span>
								<span>/&nbsp; GRASSROOTS DYNAMICS</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(2)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item, index) in nlist2" :key="item.id" @click="toDetail(item, 2)">
							<div class="soem_item1 flex3" v-if="index == 0">
								<div class="soem_item1_left">
									<img :src="item.image">
								</div>
								<div class="soem_item1_right">
									<div class="srt_date flex3">
										<img src="@/images/rili_blue.png">
										<span>{{ item.addtime.slice(0, 10) }}</span>
									</div>
									<div class="srt_pt1 ellip3">{{ item.title }}</div>
								</div>
							</div>
							<div v-if="index > 0" class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>安全生产</span>
								<span>/&nbsp; SAFE PRODUCTION</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(3)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item, index) in nlist3" :key="item.id" @click="toDetail(item, 3)">
							<div class="soem_item1 flex3" v-if="index == 0">
								<div class="soem_item1_left">
									<img :src="item.image">
								</div>
								<div class="soem_item1_right">
									<div class="srt_date flex3">
										<img src="@/images/rili_blue.png">
										<span>{{ item.addtime.slice(0, 10) }}</span>
									</div>
									<div class="srt_pt1 ellip3">{{ item.title }}</div>
								</div>
							</div>
							<div v-if="index > 0" class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>集团报刊</span>
								<span>/&nbsp; GROUP NEWSPAPERS AND MAGAZINES</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(4)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item, index) in nlist4" :key="item.id" @click="toDetail(item, 4)">
							<div class="soem_item1 flex3" v-if="index == 0">
								<div class="soem_item1_left">
									<img :src="item.image">
								</div>
								<div class="soem_item1_right">
									<div class="srt_date flex3">
										<img src="@/images/rili_blue.png">
										<span>{{ item.addtime.slice(0, 10) }}</span>
									</div>
									<div class="srt_pt1 ellip3">{{ item.title }}</div>
								</div>
							</div>
							<div v-if="index > 0" class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="nc_ph" v-if="isPhone">
			<Header2 :searchShow="true" pageTitle="新闻中心"></Header2>
			<pageBanner2 :imgurl="banner"></pageBanner2>
			<div class="news_sort">
				<div class="sort_list">
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>集团要闻</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(1)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item) in nlist1" :key="item.id" @click="toDetail(item, 1)">
							<div class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>基层动态</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(2)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item) in nlist2" :key="item.id" @click="toDetail(item, 2)">
							<div class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>安全生产</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(3)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item) in nlist3" :key="item.id" @click="toDetail(item, 3)">
							<div class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
					<div class="sort_item">
						<div class="soem_tit flex1">
							<div class="soem_tit_left">
								<span>集团报刊</span>
							</div>
							<div class="soem_tit_right" @click="toLookMore(4)">+ MORE</div>
						</div>
						<div class="tm_box" v-for="(item) in nlist4" :key="item.id" @click="toDetail(item, 4)">
							<div class="soem_item2 flex1">
								<div class="stm2_left flex3">
									<img class="youxia" src="@/images/yxjt_blue.png">
									<div class="ellip">{{ item.title }}</div>
								</div>
								<div class="stm2_right">{{ item.addtime.slice(0, 10) }}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			banner: '',
			nlist1: [],
			nlist2: [],
			nlist3: [],
			nlist4: [],
			staticImg: this.$staticImg,
			isPhone: this.$isMobile,
		}
	},
	computed: {
		...mapState(["headList"]),
	},
	mounted() {
		this.getTabArr(this.headList);
	},
	watch: {
		headList(newVal, oldVal) {
			if (newVal.length) {
				this.getTabArr(newVal);
			}
		}
	},
	created() {
		this.article();
	},
	methods: {
		getTabArr(arr) {
			for (let i = 0; i < arr.length; i++) {
				if (arr[i].name == '/newsCenter') {
					this.banner = this.$staticImg + arr[i].image;
				}
			}
		},
		async article() {
			const res = await this.$api.article();
			// 1=集团要闻,2=基层动态,3=安全生产,4=集团报刊
			if (res.code == 1) {
				this.nlist1 = res.data.data1;
				for (let i = 0; i < this.nlist1.length; i++) {
					if (this.nlist1[i].image.indexOf("http") == -1) {
                        this.nlist1[i].image = this.$staticImg+this.nlist1[i].image;
					}
				}
				this.nlist2 = res.data.data2;
                for (let i = 0; i < this.nlist2.length; i++) {
					if (this.nlist2[i].image.indexOf("http") == -1) {
                        this.nlist2[i].image = this.$staticImg+this.nlist2[i].image;
					}
				}
				this.nlist3 = res.data.data3;
                for (let i = 0; i < this.nlist3.length; i++) {
					if (this.nlist3[i].image.indexOf("http") == -1) {
                        this.nlist3[i].image = this.$staticImg+this.nlist3[i].image;
					}
				}
				this.nlist4 = res.data.data4;
                for (let i = 0; i < this.nlist4.length; i++) {
					if (this.nlist4[i].image.indexOf("http") == -1) {
                        this.nlist4[i].image = this.$staticImg+this.nlist4[i].image;
					}
				}
			}
		},
		toLookMore(a) {
			this.$router.push('/news/newsList?sort=' + a);
		},
		toDetail(item, a) {
			this.$router.push("/news/newsDetail?id=" + item.id + '&sort=' + a);
		},
	}
}
</script>

<style lang="scss">
.news_center {
	.nc_pc {
		.news_sort {
			background-color: #f6f6f6;
			padding: 75px 0;

			.sort_list {
				width: 1300px;
				margin: 0 auto;
				flex-wrap: wrap;
				align-items: flex-start;

				.sort_item {
					margin-bottom: 70px;
					background-color: #fff;
					padding: 30px 25px 40px 25px;
					border-radius: 10px;
					box-sizing: border-box;
					width: 620px;

					.soem_tit {
						padding-bottom: 15px;
						border-bottom: 1px solid #d1d1d1;
						align-items: flex-end;

						.soem_tit_left {
							span {
								&:nth-child(1) {
									padding-bottom: 15px;
									font-size: 26px;
									border-bottom: 1px solid #003f99;
								}

								&:nth-child(2) {
									margin-left: 10px;
									color: #ddd;
								}
							}
						}

						.soem_tit_right {
							color: #ddd;
							cursor: pointer;

							&:hover {
								color: #ff8041;
							}
						}
					}

					.tm_box {
						.soem_item1 {
							margin-top: 23px;
							margin-bottom: 10px;
							align-items: flex-start;

							.soem_item1_left {
								width: 240px;
								height: 160px;
								overflow: hidden;
								border-radius: 10px;

								img {
									width: 240px;
									height: 160px;
									transition: transform 0.5s ease;
									&:hover {
										transform: scale(1.05);
									}
								}
							}

							.soem_item1_right {
								margin-left: 25px;
								padding-top: 10px;
								cursor: pointer;
								flex: 1;

								.srt_date {
									img {
										width: 20px;
									}

									span {
										color: #b8b8b8;
										margin-left: 6px;
										font-size: 16px;
									}
								}

								.srt_pt1 {
									font-size: 17px;
									margin-top: 20px;
									line-height: 1.8;

									&:hover {
										color: #003f99;
									}
								}
							}
						}

						.soem_item2 {
							align-items: flex-end;
							padding: 15px 0;
							border-bottom: 1px dashed #eee;
							cursor: pointer;

							&:hover {
								.stm2_left {
									div {
										color: #003f99;
									}
								}

								.stm2_right {
									color: #333;
								}
							}

							.stm2_left {
								flex: 1;

								.youxia {
									width: 15px;
									font-weight: bold;
									margin-top: 5px;
								}

								div {
									flex: 1;
									width: 0;
									margin-left: 15px;
									font-size: 17px;
									color: #8c8c8c;
								}
							}

							.stm2_right {
								margin-left: 20px;
								font-size: 17px;
								color: #8c8c8c;
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1600px) {
		.nc_pc {
			.news_sort {
				.sort_list {
					width: 1200px;

					.sort_item {
						width: 565px;

						.tm_box {
							.soem_item1 {
								.soem_item1_left {
									width: 240px;
									height: 145px;

									img {
										width: 240px;
										height: 145px;
									}
								}

								.soem_item1_right {
									padding-top: 6px;

									.srt_date {
										span {
											font-size: 16px;
										}
									}

									.srt_pt1 {
										font-size: 17px;
										margin-top: 15px;
									}
								}
							}

							.soem_item2 {
								.stm2_left {
									div {
										font-size: 17px;
									}
								}

								.stm2_right {
									font-size: 17px;
								}
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 1400px) {
		.nc_pc {
			.news_sort {
				.sort_list {
					width: 1100px;

					.sort_item {
						width: 520px;
					}
				}
			}
		}
	}

	@media screen and (max-width: 1300px) {
		.nc_pc {
			.news_sort {
				.sort_list {
					width: 1000px;

					.sort_item {
						width: 475px;

						.tm_box {
							.soem_item1 {
								.soem_item1_left {
									width: 200px;
									height: 140px;

									img {
										width: 200px;
										height: 140px;
									}
								}
							}
						}
					}
				}
			}
		}
	}

	.nc_ph {
		padding-top: 1.23rem;
		padding-bottom: 80px;

		.news_sort {
			background-color: #f6f6f6;
			padding: 0.35rem;

			.sort_list {
				width: 100%;

				.sort_item {
					margin-bottom: 0.5rem;
					background-color: #fff;
					padding: 0.4rem;
					border-radius: 0.25rem;
					box-sizing: border-box;

					.soem_tit {
						padding-bottom: 0.35rem;
						border-bottom: 1px solid #d1d1d1;
						align-items: flex-end;

						.soem_tit_left {
							span {
								&:nth-child(1) {
									padding-bottom: 15px;
									font-size: 0.35rem;
									border-bottom: 1px solid #003f99;
								}

								&:nth-child(2) {
									margin-left: 0.25rem;
									color: #ddd;
								}
							}
						}

						.soem_tit_right {
							color: #ddd;
							cursor: pointer;

							&:hover {
								color: #ff8041;
							}
						}
					}

					.tm_box {
						.soem_item2 {
							align-items: flex-end;
							padding: 15px 0;
							border-bottom: 1px dashed #eee;
							cursor: pointer;

							&:hover {
								.stm2_left {
									div {
										color: #003f99;
									}
								}

								.stm2_right {
									color: #333;
								}
							}

							.stm2_left {
								flex: 1;

								.youxia {
									width: 15px;
									font-weight: bold;
									margin-top: 5px;
								}

								div {
									flex: 1;
									width: 0;
									margin-left: 15px;
									font-size: 18px;
									color: #8c8c8c;
								}
							}

							.stm2_right {
								margin-left: 20px;
								font-size: 17px;
								color: #8c8c8c;
							}
						}
					}
				}
			}
		}
	}
}
</style>